export const VoiceChatMutation = {
  SET_MODE: "SET_MODE",
  SET_SESSION_ID: "SET_SESSION_ID",
  SET_HIDE_NOTIFICATION_LABEL: "SET_HIDE_NOTIFICATION_LABEL",
  SET_ROOM_NUMBER: "SET_ROOM_NUMBER",
};
